import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

export const useSettings = () => {
    const [categories, setCategories] = useState([]);
    const [settings, setSettings] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    // User stats & Roles
    const [userStats, setUserStats] = useState(null);
    const [loadingStats, setLoadingStats] = useState(false);
    const [allPermissions, setAllPermissions] = useState({});
    const [loadingPermissions, setLoadingPermissions] = useState(false);



    const fetchSettings = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get('/api/settings/by_category/');
            setCategories(response.data);

            const vals = {};
            response.data.forEach((cat) => {
                cat.settings.forEach((s) => {
                    vals[s.key] = s.value;
                });
            });
            setSettings(vals);
        } catch (err) {
            setError('Error al cargar configuraciones');
        } finally {
            setLoading(false);
        }
    }, []);

    const updateSetting = async (key, value) => {
        try {
            await axios.patch(`/api/settings/${key}/`, { value });
            setSettings(prev => ({ ...prev, [key]: value }));
            return true;
        } catch (err) {
            setError(`Error al guardar '${key}'`);
            return false;
        }
    };

    const fetchUserStats = async () => {
        try {
            setLoadingStats(true);
            const response = await axios.get('/api/settings/user_stats/');
            setUserStats(response.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingStats(false);
        }
    };

    const fetchPermissions = async () => {
        try {
            setLoadingPermissions(true);
            const response = await axios.get('/api/settings/all_permissions/');
            setAllPermissions(response.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingPermissions(false);
        }
    };



    const createRole = async (name, permissions) => {
        try {
            await axios.post('/api/settings/create_role/', { name, permission_ids: permissions });
            await fetchUserStats();
            setSuccess('Rol creado exitosamente');
        } catch (err) {
            setError('Error al crear rol');
            throw err;
        }
    };

    useEffect(() => {
        fetchSettings();
    }, [fetchSettings]);

    return {
        categories,
        settings,
        loading,
        error,
        success,
        setError,
        setSuccess,
        fetchSettings,
        updateSetting,
        userStats,
        loadingStats,
        fetchUserStats,
        allPermissions,
        loadingPermissions,
        fetchPermissions,
        createRole,
    };
};
